var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLifeAndPeopleCinema(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Basics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Basics/Icons",
    transform: "translate(-2352.000000, -1442.000000)",
    fill: "#262626"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Life-and-people/Cinema",
    transform: "translate(2352.000000, 1442.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.64491774,13.6662292 L6.32780467,16.9641879 L9.32142446,16.9641879 L10.6395331,13.6662292 L13.6331529,13.6662292 L12.3160398,16.9641879 L15.3096596,16.9641879 L16.6267727,13.6662292 L19.6203924,13.6662292 L18.3032794,16.9641879 L21.2978947,16.9641879 L22.6150078,13.6662292 L25.6086276,13.6662292 L24.290519,16.9641879 L27.2851343,16.9641879 L28.6032429,13.6662292 L30,13.6662292 L30,27.9900501 C30,30.2060224 28.2129872,32 26.0078432,32 L26.0078432,32 L3.16494133,32 L3.16494133,13.6662292 L7.64491774,13.6662292 Z M14.5012727,25.9850752 L7.5154962,25.9850752 L7.5154962,27.9900501 L14.5012727,27.9900501 L14.5012727,25.9850752 Z M20.4885123,20.9741378 L7.5154962,20.9741378 L7.5154962,22.9791128 L20.4885123,22.9791128 L20.4885123,20.9741378 Z M5.71145948,7.18291021 L5.78015245,12.7778403 L3.16085958,13.6658292 L2.10458069,10.5218685 C1.75315143,9.47688154 2.31663291,8.33389583 3.35698299,7.98190023 L3.35698299,7.98190023 L5.71145948,7.18291021 Z M11.3847025,5.25883426 L11.4533955,10.8537643 L8.61707262,11.8157523 L8.54837965,6.22082224 L11.3847025,5.25883426 Z M17.0580451,3.33505831 L17.126738,8.92998838 L14.2904152,9.89197635 L14.2217222,4.29704629 L17.0580451,3.33505831 Z M22.7308898,1.41128236 L22.7995828,7.00621242 L19.96326,7.9682004 L19.894567,2.37327033 L22.7308898,1.41128236 Z M26.8913941,-6.39488462e-14 L27.947673,3.1439607 C28.2991023,4.18894764 27.7455763,5.32893339 26.6952707,5.68492894 L26.6952707,5.68492894 L25.6370008,6.04392445 L25.5673122,0.448994388 L26.8913941,-6.39488462e-14 Z",
    id: 39
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLifeAndPeopleCinema);
export default __webpack_public_path__ + "static/media/life-and-people-cinema.96b5c669.svg";
export { ForwardRef as ReactComponent };